<template>
  <el-form ref="formData" :model="formData" label-width="80px" size="mini">
    <div class="formStyle">
      <el-form-item v-for="(item) in formLabel" :key="item.prop" :label="item.label">
        <el-input-number :max=max :min="item.min" :precision="0" :step="1" v-if="item.type === 'number'" v-model="formData[item.prop]"></el-input-number>
        <el-select v-else-if="item.type === 'select'" v-model="formData[item.prop]">
          <el-option
            v-for="subItem in item.options"
            :key="subItem.value"
            :label="subItem.label"
            :value="subItem.value">
          </el-option>
        </el-select>
        <el-input v-else v-model="formData[item.prop]" :readonly="item.readonly"></el-input>

        <el-popover
          placement="top-start"
          :title="item.label"
          width="300"
          trigger="hover"
          :content="item.content">
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>

      </el-form-item>

    </div>

  </el-form>
</template>

<script>
export default {
  name: 'NodeDataForm',
  props: {
    max: {
      default: 100,
      type: Number
    },
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
    formData: Object,
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
    formLabel: Array

  },
  methods: {
    infoShow() {
      alert('000')
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep.el-input {
    width: 90%;
    line-height: 26px;
  }
  [data-v-75e4cdd0]  ::v-deep.el-input-number--mini {
    width: 90%;
    line-height: 26px;
  }
  .el-select {
    display: inline-block;
    position: relative;
    width: 90%;
  }
  .el-select > .el-input {
    display: block;
    width: 100%;
  }

</style>
<style >
  .el-popover__title {
    color: #303133;
    font-size: 14px!important;
    line-height: 1;
    margin-bottom: 12px;
  }
  .el-popover--plain {
    padding: 18px 20px;
    font-size: 11px;
  }
</style>
